export enum TreatmentPlanTableColumnNames {
  Tooth = 'TOOTH LOCATION',
  TreatmentPlan = 'ACTION',
  CostEstimates = 'COST ESTIMATE',
  PriorityDesc = 'PRIORITY',
}
